class Laenderweiche extends HTMLElement {

    static {
        if (!customElements.get("laender-weiche")) {
            customElements.define("laender-weiche", this);
        }
    }

    connectedCallback() {
        const dialog = this.querySelector("dialog");
        dialog.showModal();

        this.addEventListener("submit", this);
        dialog.addEventListener("close", () => {
            sessionStorage.setItem("laenderweiche-dismissed", "true");
        });
    }

    handleEvent(event) {
        if (event.type === "submit") {
            event.preventDefault();
            const selectedUrl = this.querySelector('input[name="country"]:checked')?.value;
            sessionStorage.setItem("laenderweiche-dismissed", "true");
            if (selectedUrl) {
                window.location.href = selectedUrl;
            } else {
                this.querySelector("dialog").close();
            }
        }
    }

}

/**
 * Wartet auf den Abschluss des Usercentrics-Consent-Dialogs, bevor callback
 * ausgeführt wird.
 *
 * Wichtig: "UC_UI_INITIALIZED" bedeutet nur, dass die CMP-Bibliothek geladen
 * und einsatzbereit ist — NICHT, dass der Nutzer bereits entschieden hat. Bei
 * Erstbesuchern feuert es praktisch sofort beim Rendern des ersten Consent-
 * Banners (live gegen das echte Usercentrics-CMP auf integration.thalia.at
 * verifiziert: isInitialized() war bereits true, während isConsentRequired()
 * weiterhin true war und der Banner sichtbar offen war). Das eigentliche
 * "Nutzer hat entschieden"-Signal ist window.UC_UI.isConsentRequired() === false
 * (z.B. gespeicherte Entscheidung eines wiederkehrenden Besuchers) bzw. das
 * Event "UC_UI_CMP_EVENT" mit type ACCEPT_ALL/DENY_ALL/SAVE (Erstbesucher
 * schließt den Banner) — ebenfalls live verifiziert.
 *
 * Ein Timeout-Fallback verhindert, dass die Länderweiche komplett ausbleibt,
 * wenn das CMP technisch gar nicht lädt (Adblocker, Netzwerkproblem). Ist
 * window.UC_UI vorhanden, das CMP aber noch nicht entschieden, wird ohne
 * weiteren Timeout auf die Entscheidung gewartet, um kein Overlay über dem
 * noch offenen Consent-Banner zu zeigen.
 */
function afterConsentDecided(callback, timeoutMs = 4000) {
    let done = false;
    const proceed = () => { if (!done) { done = true; callback(); } };

    function isDecisionEvent(event) {
        const type = event.detail?.type;
        return type === "ACCEPT_ALL" || type === "DENY_ALL" || type === "SAVE";
    }

    function onCmpReady() {
        if (!window.UC_UI.isConsentRequired?.()) {
            proceed();
            return;
        }
        window.addEventListener("UC_UI_CMP_EVENT", (event) => {
            if (isDecisionEvent(event)) {
                proceed();
            }
        });
    }

    if (window.UC_UI?.isInitialized?.()) {
        onCmpReady();
    } else {
        window.addEventListener("UC_UI_INITIALIZED", onCmpReady, { once: true });
    }

    setTimeout(() => {
        // Nur bei echtem CMP-Ausfall (window.UC_UI existiert gar nicht — Adblocker,
        // Netzwerkproblem) sofort fortfahren. Existiert window.UC_UI, wird weiter
        // auf die tatsächliche Entscheidung gewartet.
        if (!window.UC_UI) {
            proceed();
        }
    }, timeoutMs);
}

try {
    if (!sessionStorage.getItem("laenderweiche-dismissed")) {
        const template = document.getElementById("laenderweiche");
        if (template) {
            const currentMandantId = document.querySelector('meta[name="mandant"]')?.content;
            const hauptmandantId = template.dataset.hauptmandantId;
            const isHauptmandant = Boolean(hauptmandantId) && currentMandantId === hauptmandantId;

            const originCountry = document.querySelector('meta[name="origin-country"]')?.content;
            const expectedCountry = template.dataset.expectedCountry;
            const countryMismatch = Boolean(originCountry) && originCountry !== expectedCountry;

            if (isHauptmandant && countryMismatch) {
                afterConsentDecided(() => {
                    document.body.appendChild(template.content.cloneNode(true));
                });
            }
        }
    }
} catch { /* silent */ }
